import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignaturepadComponent } from './signaturepad.component';

@NgModule({
  declarations: [SignaturepadComponent],
  imports: [CommonModule],
  exports: [SignaturepadComponent]
})
export class SignaturepadModule {}
